<!--
@Time : 2020/11/29 7:17 下午
@Author : yekong
@File : haoshifenxi.vue
@Software : PhpStorm
-->
<template>
  <div>
    <titles title="纳税耗时分析"></titles>
    <div class="title2">
      本市年度纳税耗时总计为55个小时,较第一名上海差10个小时,其中耗时差别最大两部分为:账簿分子及更新汇集账簿
    </div>
    <top2></top2>
    <haoshileixing></haoshileixing>
    <haoshi2></haoshi2>
  </div>
</template>

<script>
import titles from "@/components/title";
import top2 from "@/components/nashui/top";
import haoshi2 from "@/components/nashui/haoshi2";
import haoshileixing from "@/components/nashui/haoshileixing";

export default {
  name: "haoshifenxi",
  components: {titles, top2, haoshi2, haoshileixing},
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {},
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.title2 {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
}
</style>
